import './ProjectWindow.css';
import { Scroller } from './Scroller';
import './Scroller.css';

function ProjectWindow({icon, name, description, link, workTags = ['none', 'nothing', 'nada', 'nope', 'empty']}){
    const tagsList = workTags.map((tag) => ({
      id: crypto.randomUUID(),
      tag
    }));

    return(
      <div className="projectWindow">
        <img src={icon}></img>
        <h1>{name}</h1>
        <p>{description}</p>
        <Scroller 
          tags={tagsList}
          speed={15000}
        />
        <a href={link}>
          <button>Take a look</button>
        </a>
      </div>
    );
}

export default ProjectWindow;